<template>
  <AppVerticalNav>
    <AppLink
      v-for="(tab, index) in tabs"
      :key="index"
      :active="tab.active"
      :url="tab.url"
    >
      {{ tab.name }}
    </AppLink>
  </AppVerticalNav>
</template>

<script>
export default {
  name: 'MemberProfilesNav',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
